<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createProductoPaginaIdroop"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductSalesLettersModalCreateExternalSite.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        key="modal section"
        class="m-the-modal-section-height-auto"
      >
        <blockquote class="quote quote-products-primary quote-first">
          <p>
            {{ $t('mEditionProductSalesLettersModalCreateExternalSite.quote') }}
          </p>
        </blockquote>
        <AtomInputPrimary
          v-model="carta.nombre"
          :inputError="$v.carta.nombre.$error"
          :label="$t('mEditionProductSalesLettersModalCreateExternalSite.inputs.nombre.label')"
          :message="$t('mEditionProductSalesLettersModalCreateExternalSite.inputs.nombre.message')"
          :messageError="messageErrorNombre"
          name="nombre"
          :placeholder="$t('mEditionProductSalesLettersModalCreateExternalSite.inputs.nombre.placeholder')"
          type="text"
          @blur="$v.carta.nombre.$touch()"
        />
        <AtomInputPrimary
          v-model="carta.url"
          :inputError="$v.carta.url.$error"
          :label="$t('mEditionProductSalesLettersModalCreateExternalSite.inputs.url.label')"
          :messageError="messageErrorUrl"
          name="url"
          :placeholder="$t('mEditionProductSalesLettersModalCreateExternalSite.inputs.url.placeholder')"
          type="text"
          @blur="$v.carta.url.$touch()"
        />
        <p class="font-weight-light">
          {{ $t('mEditionProductSalesLettersModalCreateExternalSite.productUrlFormMessage') }}
        </p>
        <p>
          <a
            class="font-weight-bold text-link-hover-products"
            :href="productUrlForm"
            target="_blank"
          >
            {{ productUrlForm }}
          </a>
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductSalesLettersModalCreateExternalSite.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required, url } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionProductSalesLettersModalCreateExternalSite',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductSalesLettersModalCreateExternalSite.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      carta: {
        nombre: '',
        tipo: 0,
        externo: 1,
        url: '',
        producto: this.$route.params.id
      },

      productUrlForm: ''
    }
  },

  validations: {
    carta: {
      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(1),
        required
      },

      url: {
        required,
        url
      }
    }
  },

  computed: {

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionProductSalesLettersModalCreateExternalSite', this.$v.carta.nombre, 'nombre')
    },

    messageErrorUrl () {
      return this.$validation.getValidationMessage('mEditionProductSalesLettersModalCreateExternalSite', this.$v.carta.url, 'url')
    }
  },

  created () {
    this.productUrlForm = `${this.$utils.getMarketPlaceDomain()}/${this.$store.getters.getAcademyData.url}/producto/${this.$route.params.id}/comprar`
  },

  methods: {
    createProductoPaginaIdroop () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('producto', 'createProductoPaginaIdroop', this.carta)
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductSalesLettersModalCreateExternalSite', 'createProductoPaginaIdroop', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductSalesLettersModalCreateExternalSite', 'createProductoPaginaIdroop', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
